import JourneyActivityMapSurface from '../journey-spatial/JourneyActivityMapSurface';

/**
 * AUTH59 — Planning map surface 適配器；文案／testid／CSS 維持既有 Planning 產品語意。
 * Wave 3：可選 placePickEnabled／onPlacePick（PD-MAP-01）。
 */
export default function PlanningMapSurface({
  markers,
  selectedKey,
  onSelectMarker,
  placePickEnabled = false,
  onPlacePick = null,
}) {
  return (
    <JourneyActivityMapSurface
      markers={markers}
      selectedKey={selectedKey}
      onSelectMarker={onSelectMarker}
      placePickEnabled={placePickEnabled}
      onPlacePick={onPlacePick}
      title="規劃地圖"
      emptyDescription="顯示已儲存且有座標的安排位置。未座標活動仍會留在清單中。"
      disabledWarning="地圖互動尚未啟用；標記仍會以相對位置顯示。"
      showLegend
      classPrefix="journey-planning-map"
      testId="planning-map"
      emptyTestId="planning-map-empty"
      googleTestId="planning-map-google"
      loadingTestId="planning-map-google-loading"
      planeAriaLabel="Journey activity markers"
      mapAriaLabel="Journey activity map"
    />
  );
}
